/**
 * detection-odors-context.js
 * provides access to current expanded id and current expanded "done" handler
 * so we can attempt to run the open section's "done" handler when saving the record.
 */

import React from "react";


export const DetectionOdorsContext = React.createContext({
  expandedId: null,
  currentDoneHandler: null,
});


export const DetectionOdorsProvider = ({ children }) => {
  const [state, setState] = React.useState({ 
    expandedId: null,
    currentDoneHandler: null 
  });


  const setExpandedId = React.useCallback((expandedId) => {
    setState(p => ({
      ...p,
      expandedId
    }));
  }, []);


  const setCurrentDoneHandler = React.useCallback((currentDoneHandler) => {
    setState(p => ({
      ...p,
      currentDoneHandler
    }));
  }, []);


  // final state value
  const value = React.useMemo(() => ({
    ...state,
    setExpandedId,
    setCurrentDoneHandler,
  }), [
    state,
    setExpandedId,
    setCurrentDoneHandler,
  ]);


  return (
    <DetectionOdorsContext.Provider value={value}>
      {children}
    </DetectionOdorsContext.Provider>
  );
};